import { ORDER } from '@arpeggi/shared'

export interface BasePaginationParams {
  page?: number
  perPage?: number
  order?: ORDER
}
